@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="header-with-actions">
      <mat-expansion-panel expanded hideToggle="true">
        <mat-expansion-panel-header class="event-disabled d-flex align-items-center">
          <mat-panel-title>
            {{'pages.document.all-document-management.component.manage-documents' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="container background-filters py-3 px-5 mt-3">
          <div class="row justify-content-between">
            <div class="purple-color">
              <h2>{{'generic.search-for' | translate}}</h2>
            </div>
            <div>
              <button class="clear-filter py-2 px-4" (click)="onClearSearch()">{{'generic.reset-filters' | translate}} <i class="icon-Close ml-2 size"></i></button>
            </div>
          </div>

          <!-- SECONDA ROW FILTRI-->
          <div class="row d-flex justify-content-between mx-0 mt-0">
            <div class="col-12 col-md-12 mt-4">
              <mat-form-field class="full-width">
                <input matInput name="searchKeywords" [(ngModel)]="searchTerm" (input)="onSearch()" type="text" placeholder="{{'pages.document.all-documents-management.component.search-name' | translate}}" #searchInput>
                @if (searchTerm) {
                  <mat-icon class="with-cursor" matSuffix aria-label="Clear" (click)="searchTerm=''; onSearch()">close</mat-icon>
                }
                <mat-icon class="purple-color with-cursor" matSuffix aria-label="Clear" (click)="onSearch()">search</mat-icon>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- ADD DOCUMENT BUTTON -->
        <div class="row">
          <div class="col-12 d-flex justify-content-end align-items-center">
            <button class="btn-custom btn-magic-add d-flex align-items-center px-5 py-2 mt-3 mb-3" (click)="onClickUploadDocument()">
              <mat-icon class="mr-2">add</mat-icon>
              {{'pages.document.all-documents-management.component.add-document' | translate}}
            </button>
          </div>
        </div>

        <!-- TABLE -->
        @if (!loading && documentsData && documentsData?.data && documentsData.data.length > 0) {
        <div class="row">
          <div class="col-12 px-2 mb-4">
            <mat-table [dataSource]="documentsData" class="table-primary">
              <!-- Title Column -->
              <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef>{{'generic.title' | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element?.title) {
                    <span><a role="button" (click)="showDocument(element)" >{{element?.title}}</a></span>
                  }
                </mat-cell>
              </ng-container>
              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element" class="d-flex py-3" style="justify-content:right;">
                  <button mat-button color="primary" [disableRipple]="true" (click)="showDocument(element)"> {{'tooltip.show' | translate}}</button>
                  <button mat-icon-button color="warn" [disableRipple]="true" (click)="deleteDocument(element)" matTooltip="{{'tooltip.delete' | translate}}" [matTooltipPosition]="'above'" ><fa-icon [icon]="faTrash"></fa-icon></button>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
            <!-- <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of users"></mat-paginator> -->
          </div>
        </div>
        }

        <!-- No data-->
        @if (!loading && documentsData && documentsData?.data?.length === 0) {
          <div class="col-12 text-center d-flex flex-column align-items-center">
            <img src="assets/img/no-files.png" alt="" class="no-files-img mb-3">
            <h3 class="color-green">{{'pages.document.all-docuements-table.component.no-filtered-documents-tables' | translate}}</h3>
          </div>
        }

      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
<div class="buttons-container container py-4">
  <button class="button-primary float-left" mat-button [routerLink]="['../']" routerLinkActive="router-link-active">
    <i class="icon-Backward-arrow-small"></i>
    {{'generic.buttons.back' | translate}}
  </button>
</div>
